<template>

  <div>
    <!-- Filters -->
    <!--    <Filters-->
    <!--        :role-filter.sync="roleFilter"-->
    <!--        :plan-filter.sync="planFilter"-->
    <!--        :status-filter.sync="statusFilter"-->
    <!--        :role-options="roleOptions"-->
    <!--        :plan-options="planOptions"-->
    <!--        :status-options="statusOptions"-->
    <!--    />-->

    <!-- Table Container Card -->
    <b-card
        no-body
        class="mb-0"
    >

      <div class="m-2">

        <!-- Table Top -->
        <b-row>

          <!-- Per Page -->
          <b-col
              cols="12"
              md="6"
              class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <label>Mostrar</label>
            <v-select
                v-model="perPage"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="perPageOptions"
                :clearable="false"
                class="per-page-selector d-inline-block mx-50"
            />
            <label>entradas</label>
          </b-col>

          <!-- Search -->
          <b-col
              cols="12"
              md="6"
          >
            <div class="d-flex align-items-center justify-content-end">
              <b-form-input
                  v-model="searchQuery"
                  class="d-inline-block mr-1"
                  placeholder="Pesquisar..."
              />
              <b-button
                  variant="primary"
                  :to="{ name: 'imagens-login-novo' }"
                  class="d-flex"
              >
                <feather-icon
                    icon="PlusIcon"
                    class="mr-50"
                />
                <span class="align-middle">Criar</span>
              </b-button>
            </div>
          </b-col>
        </b-row>

      </div>

      <b-table
          ref="refDataTableImagemLogin"
          class="position-relative"
          :items="fetchImagemLogin"
          responsive
          :fields="tableColumns"
          primary-key="log_img_id"
          :sort-by.sync="sortBy"
          show-empty
          empty-text="Nenhum registro encontrado"
          :sort-desc.sync="isSortDirDesc"
      >

        <template #cell(url)="data">
          <b-img class="mb-1 mb-sm-0" height="100%" width="120" :src="data.value"
                 :alt="`Imagem id ${data.item.url}`"/>
        </template>

        <!-- Column: Actions -->
        <template #cell(actions)="data">
          <div class="d-flex">
            <b-button
                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                title="Visualizar"
                variant="flat-success"
                :to="{ name: 'imagens-login-edit-id', params: { id: data.item.log_img_id } }"
                class="btn-icon"
            >
              <feather-icon
                  icon="EyeIcon"
                  size="20"
              />
            </b-button>

            <b-button
                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                title="Deletar"
                variant="flat-danger"
                @click="showModalDeleteImagemLogin(data.item.log_img_id)"
                class="btn-icon"
            >
              <feather-icon
                  icon="TrashIcon"
                  size="20"
              />
            </b-button>
          </div>
        </template>

      </b-table>
      <div class="mx-2 mb-2">
        <b-row>

          <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-start"
          >
            <span class="text-muted">Mostrando {{ dataMeta.from }} para {{ dataMeta.to }} de {{
                dataMeta.of
              }} entradas</span>
          </b-col>
          <!-- Pagination -->
          <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-end"
          >

            <b-pagination
                v-model="currentPage"
                :total-rows="totalUsers"
                :per-page="perPage"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
            >
              <template #prev-text>
                <feather-icon
                    icon="ChevronLeftIcon"
                    size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                    icon="ChevronRightIcon"
                    size="18"
                />
              </template>
            </b-pagination>

          </b-col>

        </b-row>
      </div>
    </b-card>

    <modal-confirmation
        v-model="isDeleteModal"
        id-modal="modal-delete-imagem-login"
        title="Deletar Imagem Login"
        message="Tem certeza que deseja deletar?"
        btn-cancel-label="Cancelar"
        btn-ok-label="sim, deletar"
        @ok="deleteImagemLogin"
        @cancel="isDeleteModal = false"
    />
  </div>
</template>

<script>
import { ref } from '@vue/composition-api';
import { avatarText } from '@core/utils/filter';
import ModalConfirmation from '@/components/ModalConfirmation.vue';
import HbiImagemLoginService from '@/services/SistemaDKP/sls-imagem-login.service';
import useList from './useList';
import Filters from './Filters.vue';

export default {
  components: {
    ModalConfirmation,
    Filters,
  },
  setup() {
    const isDeleteModal = ref(false);
    const imagemLoginService = new HbiImagemLoginService();
    const idImagemLoginDelete = ref(null);
    const roleOptions = [
      { label: 'Admin', value: 'admin' },
      { label: 'Author', value: 'author' },
      { label: 'Editor', value: 'editor' },
      { label: 'Maintainer', value: 'maintainer' },
      { label: 'Subscriber', value: 'subscriber' },
    ];

    const planOptions = [
      { label: 'Basic', value: 'basic' },
      { label: 'Company', value: 'company' },
      { label: 'Enterprise', value: 'enterprise' },
      { label: 'Team', value: 'team' },
    ];

    const statusOptions = [
      { label: 'Pending', value: 'pending' },
      { label: 'Active', value: 'active' },
      { label: 'Inactive', value: 'inactive' },
    ];

    const {
      fetchImagemLogin,
      tableColumns,
      perPage,
      currentPage,
      totalUsers,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refDataTableImagemLogin,
      refetchData,

      // UI
      resolveUserRoleVariant,
      resolveUserRoleIcon,
      resolveUserStatusVariant,

      // Extra Filters
      roleFilter,
      planFilter,
      statusFilter,
    } = useList();

    const showModalDeleteImagemLogin = (id) => {
      idImagemLoginDelete.value = id;
      isDeleteModal.value = true;
    };
    const deleteImagemLogin = async () => {
      await imagemLoginService.delete(idImagemLoginDelete.value);
      isDeleteModal.value = false;
      refetchData();
    };

    return {

      // Sidebar
      isDeleteModal,

      fetchImagemLogin,
      tableColumns,
      perPage,
      currentPage,
      totalUsers,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refDataTableImagemLogin,
      refetchData,

      // Filter
      avatarText,

      // UI
      resolveUserRoleVariant,
      resolveUserRoleIcon,
      resolveUserStatusVariant,

      roleOptions,
      planOptions,
      statusOptions,

      // Extra Filters
      roleFilter,
      planFilter,
      statusFilter,
      deleteImagemLogin,
      showModalDeleteImagemLogin,
    };
  }
  ,
};
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
